import BreadCrumb from "Components/Common/BreadCrumb";
import React from "react";
import { Container } from "reactstrap";
import BasicInformation from "./Components/BasicInformation";
import { useSelector } from "react-redux";
import UserNavTabs from "./Components/UserNavTabs";
// user detail page
const UserDetailPage = () => {
  document.title = "User Details";
  const userId = useSelector((state: any) => state.User.selectedUserId);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb 
            title="User Details" 
            pageTitles={[
              { label: "Users", path: "/users" },
              { label: "User Details" }
            ]}
          />
          <div>
            <BasicInformation id={userId}/>
          </div>
          <div>
            <UserNavTabs />
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserDetailPage;
